const style = (theme) => {
  const output = {
    root: {
      width: '100%',
      overflow: 'hidden',
      transform: 'translateZ(0)',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      position: 'relative',
    },
    reverse: {
      justifyContent: 'flex-end',
    },
    groupContainer: {
      width: 'auto',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      position: 'relative',
    },
    railContainer: {
      display: 'flex',
      width: 'auto',
      whiteSpace: 'nowrap',
    },
    railTrack: {
      display: 'inline-block',
    },
    text: {
      paddingLeft: 40,
      fontFamily: theme.fonts[0],
      textTransform: 'uppercase',
      lineHeight: 1,
      fontSize: '8vw',
      letterSpacing: '2px',
      display: 'flex',
      alignItems: 'center',
      '& span': {
        display: 'block',
      },
      '& a': {
        '&:hover': {
          '& span': {
            transform: 'skew(-10deg, 0)',
          },
        },
      },
    },
    label: {
      fontWeight: 300,
      color: theme.getRgba(theme.colors[1], 0.2),
    },
    title: {
      fontWeight: 600,
      color: theme.getRgba(theme.colors[1], 0.2),
    },
    image: {
      marginRight: 40,
      marginLeft: 40,
      width: '20vw',
      '& div': {
        width: '100%',
        paddingBottom: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      },
    },
  }

  return output
}

export default style
